var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// filepath: /D:/xamp8.2/htdocs/chaseit1416/resources/js/Pages/components/Schedule.tsx
import React, { useEffect, useState, useRef } from "react";
import useChaseListNavigate from "../../hooks/useChaseListNavigate";
import useFetchTimeLogs from "../../hooks/useFetchTimeLogs";
import Spinner from "../../components/Spinner";
import { toast, ToastContainer } from "react-toastify";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import CustomDayView from "./time_log/CustomDayView";
import CustomDayTimeLog from "./time_log/CustomDayTimeLog";
import AgendaEventTimeLog from "./time_log/TimeLogAgendaEvent";
import { CustomWeekEvent } from "./time_log/CustomWeekEvent";
import AddTimeLogs from "../../components/modals/AddTimeLogs";
import useFetchUserProfile from "../../hooks/useFetchUserProfile";
import { useDispatch, useSelector } from "react-redux";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { reloadTimeLogs } from "../../store/slices/reloadSlice";
import axios from "axios";
import { setDeductions, setGlobalCalendarEvents } from "../../store/slices/siteSlice";
import { CustomToolbar } from "./calendar/CustomToolbar";
import images from "../../utils/Images";
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
var localizer = momentLocalizer(moment);
var TimeLogs = function () {
    var chaseListNavigate = useChaseListNavigate();
    var _a = useFetchTimeLogs(), events = _a.events, deductions = _a.deductions, holidays = _a.holidays, loading = _a.loading, error = _a.error, fetchTimeLogs = _a.fetchTimeLogs, groupedEvents = _a.groupedEvents, positions = _a.positions;
    var _b = useState(undefined), strikeFundPercentage = _b[0], setStrikeFundPercentage = _b[1];
    var isReloadedTimeLogs = useSelector(function (state) { return state.reload.isReloadedTimeLogs; });
    var _c = useFetchUserProfile(), userProfile = _c.userProfile, fetchUserProfile = _c.fetchUserProfile;
    var _d = useState({}), editData = _d[0], setEditData = _d[1];
    var _e = useState([]), calendarEvents = _e[0], setCalendarEvents = _e[1];
    var _f = useState(0), monthlyEarnings = _f[0], setMonthlyEarnings = _f[1];
    var _g = useState(0), monthlyHours = _g[0], setMonthlyHours = _g[1];
    var _h = useState([]), weeklyEarnings = _h[0], setWeeklyEarnings = _h[1];
    var _j = useState(0), dailyGrossEarnings = _j[0], setDailyGrossEarnings = _j[1];
    var _k = useState(0), dailyNetEarnings = _k[0], setDailyNetEarnings = _k[1];
    var _l = useState([]), deductedList = _l[0], setDeductedList = _l[1];
    var _m = useState([]), seasonalStats = _m[0], setSeasonalStats = _m[1];
    var _o = useState([]), dailyHourlyEarnings = _o[0], setDailyHourlyEarnings = _o[1];
    var _p = useState("month"), view = _p[0], setView = _p[1];
    var _q = useState(new Date()), date = _q[0], setDate = _q[1];
    var _r = useState(""), dateWithoutTimeZone = _r[0], setDateWithoutTimeZone = _r[1];
    var _s = useState(false), showAddLogModal = _s[0], setShowAddLogModal = _s[1];
    var _t = useState(false), showEditLogModal = _t[0], setShowEditLogModal = _t[1];
    var _u = useState(""), seniority = _u[0], setSeniority = _u[1];
    var isLoggedIn = useSelector(function (state) { return state.user.isLoggedIn; });
    var dispatch = useDispatch();
    // Keep the latest seniority accessible across async handlers
    var seniorityRef = useRef(seniority);
    useEffect(function () {
        seniorityRef.current = String(seniority !== null && seniority !== void 0 ? seniority : "");
    }, [seniority]);
    useEffect(function () {
        if (userProfile)
            setSeniority(userProfile.seniority || "");
    }, [userProfile]);
    // Fetch time logs
    var getTimeLogs = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchTimeLogs()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (error)
            toast.error(error);
    }, [error]);
    // ---------------------- //
    //  🧮 Unified Calculation
    // ---------------------- //
    var calculateEarnings = function (dateActive) {
        var _a;
        var year = dateActive.getFullYear();
        var month = dateActive.getMonth();
        var startOfYear = new Date(year, 0, 1);
        var endOfYear = new Date(year, 11, 31, 23, 59, 59, 999);
        // Filter events for the current year
        var yearlyEvents = calendarEvents.filter(function (e) { return e.start <= endOfYear && e.end >= startOfYear; });
        // Calculate seasonal stats Season starts October 1st - September 30th every year.
        var seasonalEvents = yearlyEvents.reduce(function (acc, e) {
            var _a;
            var eventDate = e.start instanceof Date ? e.start : new Date(e.start);
            var seasonStartYear = eventDate.getMonth() >= 9 ? eventDate.getFullYear() : eventDate.getFullYear() - 1;
            var seasonKey = seasonStartYear.toString();
            var parsedAmount = parseFloat((_a = e.content) !== null && _a !== void 0 ? _a : "0");
            var start = e.start instanceof Date ? e.start : new Date(e.start);
            var end = e.end instanceof Date ? e.end : new Date(e.end);
            var startMoment = moment(start);
            var endMoment = moment(end);
            // Check if the event spans midnight
            if (endMoment.isBefore(startMoment)) {
                endMoment.add(1, "day"); // Add 1 day to the end time
            }
            // Calculate the duration in hours
            var durationHours = Math.max(0, endMoment.diff(startMoment, "hours", true));
            if (!acc[seasonKey])
                acc[seasonKey] = { amount: 0, hours: 0 };
            acc[seasonKey].amount += Number.isNaN(parsedAmount) ? 0 : parsedAmount;
            acc[seasonKey].hours += durationHours;
            return acc;
        }, {});
        var seasonalArray = Object.keys(seasonalEvents).map(function (k) { return ({
            amount: seasonalEvents[k].amount,
            hours: seasonalEvents[k].hours,
            year: k.toString(),
        }); });
        setSeasonalStats(seasonalArray);
        console.log("seasonalArray", seasonalArray);
        var startOfMonth = new Date(year, month, 1);
        var endOfMonth = new Date(year, month + 1, 0, 23, 59, 59, 999);
        // Get all events within this month
        var monthlyEvents = calendarEvents.filter(function (e) { return e.start <= endOfMonth && e.end >= startOfMonth; });
        // 1️⃣ Monthly Total
        var monthlyTotal = monthlyEvents.reduce(function (sum, e) {
            var _a;
            var parsed = parseFloat((_a = e.content) !== null && _a !== void 0 ? _a : "0");
            return sum + (Number.isNaN(parsed) ? 0 : parsed);
        }, 0);
        var monthlyHours = monthlyEvents.reduce(function (sum, e) {
            var start = e.start instanceof Date ? e.start : new Date(e.start);
            var end = e.end instanceof Date ? e.end : new Date(e.end);
            var duration = (end.getTime() - start.getTime()) / (1000 * 60 * 60);
            return sum + (duration > 0 ? duration : 0);
        }, 0);
        setMonthlyHours(monthlyHours);
        // 2️⃣ Weekly Totals (Wednesday → Tuesday)
        var weeks = [];
        var day = startOfMonth.getDay();
        var diffToWednesday = (day - 3 + 7) % 7;
        var firstWednesday = new Date(startOfMonth);
        firstWednesday.setDate(startOfMonth.getDate() - diffToWednesday);
        firstWednesday.setHours(0, 0, 0, 0);
        var current = new Date(firstWednesday);
        while (current <= endOfMonth) {
            var weekStart = new Date(current);
            var weekEnd = new Date(current);
            weekEnd.setDate(weekEnd.getDate() + 6); // Wednesday + 6 = Tuesday
            weekEnd.setHours(23, 59, 59, 999);
            weeks.push({ from: weekStart, to: weekEnd });
            current.setDate(current.getDate() + 7);
        }
        // const weeks: { from: Date; to: Date }[] = [];
        // const day = startOfMonth.getDay();
        // const diffToTuesday = (day - 2 + 7) % 7;
        // const firstTuesday = new Date(startOfMonth);
        // firstTuesday.setDate(startOfMonth.getDate() - diffToTuesday);
        // firstTuesday.setHours(0, 0, 0, 0);
        // let current = new Date(firstTuesday);
        // while (current <= endOfMonth) {
        //   const weekStart = new Date(current);
        //   const weekEnd = new Date(current);
        //   weekEnd.setDate(weekEnd.getDate() + 6);
        //   weekEnd.setHours(23, 59, 59, 999);
        //   weeks.push({ from: weekStart, to: weekEnd });
        //   current.setDate(current.getDate() + 7);
        // }
        // Weekly breakdown: include all events that overlap the week, not just those in the month
        var weeklyData = weeks.map(function (_a) {
            var from = _a.from, to = _a.to;
            var weekEvents = calendarEvents.filter(function (e) { return e.end >= from && e.start <= to; });
            var amount = weekEvents.reduce(function (sum, e) {
                var _a;
                var parsed = parseFloat((_a = e.content) !== null && _a !== void 0 ? _a : "0");
                return sum + (Number.isNaN(parsed) ? 0 : parsed);
            }, 0);
            var hours = weekEvents.reduce(function (sum, e) {
                var start = e.start instanceof Date ? e.start : new Date(e.start);
                var end = e.end instanceof Date ? e.end : new Date(e.end);
                var startMoment = moment(start);
                var endMoment = moment(end);
                // Handle overnight events
                if (endMoment.isBefore(startMoment)) {
                    endMoment.add(1, "day");
                }
                // Handle events that span multiple weeks
                if (startMoment.isBefore(from)) {
                    startMoment = moment(from); // Adjust start time to the beginning of the week
                }
                if (endMoment.isAfter(to)) {
                    endMoment = moment(to); // Adjust end time to the end of the week
                }
                var duration = Math.max(0, endMoment.diff(startMoment, "hours", true));
                return sum + duration;
            }, 0);
            return { from: from, to: to, amount: amount, hours: hours };
        });
        // 3️⃣ Daily Totals & Hourly Breakdown
        var today = dateActive;
        var startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        var endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999);
        var dailyEvents = calendarEvents.filter(function (e) { return e.start >= startOfDay && e.end <= endOfDay; });
        var total = 0;
        var hourlyRates = [];
        var _loop_1 = function (event) {
            var _b;
            var start = event.start instanceof Date ? event.start : new Date(event.start);
            var end = event.end instanceof Date ? event.end : new Date(event.end);
            var parsed = parseFloat((_a = event.content) !== null && _a !== void 0 ? _a : "0");
            if (Number.isNaN(parsed))
                return "continue";
            total += parsed;
            var duration = (end.getTime() - start.getTime()) / (1000 * 60 * 60);
            if (duration <= 0) {
                // Handle overnight events by adding 24 hours to the end time
                // debugger;
                duration = ((end.getTime() + 24 * 60 * 60 * 1000) - start.getTime()) / (1000 * 60 * 60);
            }
            ;
            var rate = parsed / duration;
            var existing = hourlyRates.find(function (r) { return r[rate]; });
            if (existing)
                existing[rate] += parsed;
            else
                hourlyRates.push((_b = {}, _b[rate] = parsed, _b));
        };
        for (var _i = 0, dailyEvents_1 = dailyEvents; _i < dailyEvents_1.length; _i++) {
            var event = dailyEvents_1[_i];
            _loop_1(event);
        }
        // Save all results
        setMonthlyEarnings(monthlyTotal);
        setWeeklyEarnings(weeklyData);
        setDailyGrossEarnings(total);
        setDailyHourlyEarnings(hourlyRates);
    };
    useEffect(function () {
        var netTotal = dailyGrossEarnings;
        setDeductedList([]);
        var _loop_2 = function (deduction) {
            var deductionPercentage = parseFloat(deduction.amount);
            var deductedAmount = (deductionPercentage / 100) * dailyGrossEarnings;
            setDeductedList(function (prev) { return __spreadArray(__spreadArray([], prev, true), [{ label: deduction.label, deducated: deductedAmount }], false); });
            netTotal -= deductedAmount;
        };
        for (var _i = 0, deductions_1 = deductions; _i < deductions_1.length; _i++) {
            var deduction = deductions_1[_i];
            _loop_2(deduction);
        }
        setDailyNetEarnings(netTotal);
    }, [dailyGrossEarnings]);
    // ---------------------- //
    //        EFFECTS
    // ---------------------- //
    useEffect(function () {
        dispatch(setDeductions(deductions));
        if (events.length > 0) {
            var formatted = events.map(function (event) { return ({
                id: event.id,
                start: new Date(event.start),
                end: new Date(event.end),
                title: event.title,
                content: event.content,
                class: event.class,
                group: event.groupId,
                resource: event.groupId,
                date: event.date,
                is_break: event.is_break,
                header_name: event.header_name,
                ship_name: event.ship_name,
                position_relation: event.position_relation,
                vessel: event.vessel,
            }); });
            setCalendarEvents(formatted);
            dispatch(setGlobalCalendarEvents(formatted));
        }
        else {
            setCalendarEvents([]);
            dispatch(setGlobalCalendarEvents([]));
        }
    }, [events]);
    useEffect(function () {
        for (var _i = 0, deductions_2 = deductions; _i < deductions_2.length; _i++) {
            var deduction = deductions_2[_i];
            if (deduction.label.toLowerCase() === "strike fund") {
                var percentage = parseFloat(deduction.amount);
                if (!Number.isNaN(percentage)) {
                    setStrikeFundPercentage(percentage);
                }
                break;
            }
        }
    }, [deductions]);
    useEffect(function () {
        calculateEarnings(date);
    }, [calendarEvents, isReloadedTimeLogs]);
    useEffect(function () {
        var asyncMethod = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getTimeLogs()];
                    case 1:
                        _a.sent();
                        calculateEarnings(date);
                        return [2 /*return*/];
                }
            });
        }); };
        asyncMethod();
    }, [isReloadedTimeLogs]);
    // Custom toolbar for react-big-calendar (customize monthly navigation UI)
    // Listen for global event to open Add Log modal (dispatched from other UI like bottom nav)
    useEffect(function () {
        // Wait until seniority is loaded (or up to a max delay)
        var waitUntilSeniorityReady = function (maxWaitMs, intervalMs) {
            if (maxWaitMs === void 0) { maxWaitMs = 1000; }
            if (intervalMs === void 0) { intervalMs = 100; }
            return new Promise(function (resolve) {
                var start = Date.now();
                var check = function () {
                    var s = String(seniorityRef.current).trim();
                    if (s !== "" || Date.now() - start >= maxWaitMs) {
                        resolve();
                    }
                    else {
                        setTimeout(check, intervalMs);
                    }
                };
                check();
            });
        };
        var handler = function (e) { return __awaiter(void 0, void 0, void 0, function () {
            var s;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isLoggedIn)
                            return [2 /*return*/];
                        return [4 /*yield*/, waitUntilSeniorityReady()];
                    case 1:
                        _a.sent();
                        s = String(seniorityRef.current).trim();
                        if (s === "") {
                            toast.error("Please set your seniority in Profile before adding time logs.");
                            return [2 /*return*/];
                        }
                        setShowAddLogModal(true);
                        return [2 /*return*/];
                }
            });
        }); };
        window.addEventListener('open-add-log', handler);
        return function () { return window.removeEventListener('open-add-log', handler); };
    }, [isLoggedIn]);
    var handleDateClick = function (date) {
        setView("day");
        setDate(date);
        setDateWithoutTimeZone(date.toISOString().split("T")[0]);
        calculateEarnings(date);
    };
    var isHoliday = function (date) {
        return holidays.some(function (holiday) { return moment(holiday.date).isSame(date, 'day'); });
    };
    var dayPropGetter = function (date) {
        if (isHoliday(date)) {
            return {
                // You can add a custom CSS class for styling
                className: 'holiday-cell',
                style: {
                    backgroundColor: '#ffb8b8ff', // Example background color
                },
            };
        }
        return {};
    };
    var handleDeleteEvent = function (eventId) { return __awaiter(void 0, void 0, void 0, function () {
        var isConfirmed, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isConfirmed = confirm('Are you sure you want to delete this time log?');
                    if (!isConfirmed) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.delete("/time_logs_by_uuid/".concat(eventId), {
                            headers: {
                                "Content-Type": "application/json",
                            },
                        })];
                case 2:
                    response = _a.sent();
                    console.log("response", response);
                    if (response.status === 200) {
                        toast.success(response.data.message);
                        dispatch(reloadTimeLogs());
                        // Optionally, trigger a refresh or update the UI
                    }
                    else if (response.status === 401) {
                        toast.error(response.data.message);
                    }
                    else {
                        toast.error(response.data.message);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    toast.error("An error occurred while deleting the time log.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var groupedEventsComponent = Object.keys(groupedEvents)
        .sort(function (a, b) {
        // Sort entries by their end time to ensure chronological order
        var eventsA = groupedEvents[a];
        var eventsB = groupedEvents[b];
        var startA = moment(eventsA[0].date + ' ' + eventsA[0].start_time);
        var startB = moment(eventsB[0].date + ' ' + eventsB[0].start_time);
        var endA = moment(eventsA[eventsA.length - 1].date + ' ' + eventsA[eventsA.length - 1].end_time);
        var endB = moment(eventsB[eventsB.length - 1].date + ' ' + eventsB[eventsB.length - 1].end_time);
        // Handle midnight crossing for entry A
        if (endA.isBefore(startA)) {
            endA = endA.add(1, 'day');
        }
        // Handle midnight crossing for entry B  
        if (endB.isBefore(startB)) {
            endB = endB.add(1, 'day');
        }
        // Sort by end time (midnight-crossing entries will be at the end)
        return endA.valueOf() - endB.valueOf();
    })
        .map(function (dateKey) {
        var eventsForDate = groupedEvents[dateKey];
        var notExists = true;
        var entryTotal = 0;
        var selectedBreaks = [];
        eventsForDate.forEach(function (element) {
            // if(element.date === moment(date).format("YYYY-MM-DD")){ 
            notExists = false;
            entryTotal = parseFloat(element.cost) + entryTotal;
            if (element.is_break)
                selectedBreaks.push("".concat(moment(element.start_time, 'hh:mm').format('hh:mm'), "-").concat(moment(element.end_time, 'hh:mm').format('hh:mm')));
            // }
        });
        if (notExists) {
            return null;
        }
        var first_start_time = moment(eventsForDate[0].date + ' ' + eventsForDate[0].start_time);
        // Calculate proper end time - if end time is earlier than start time, it crosses midnight
        var last_end_time = moment(eventsForDate[eventsForDate.length - 1].date + ' ' + eventsForDate[eventsForDate.length - 1].end_time);
        // Check if end time appears to be before start time (indicating midnight crossing)
        if (last_end_time.isBefore(first_start_time)) {
            // Add one day to end time to represent next day
            last_end_time = last_end_time.add(1, 'day');
        }
        var existatStart = moment(date).isSame(first_start_time, "day");
        var existatEnd = moment(date).isSame(last_end_time, "day");
        if (!existatStart && !existatEnd) {
            return null;
        }
        // Check if shift crosses midnight (spans multiple days)
        var crossesMidnight = !first_start_time.isSame(last_end_time, 'day');
        if (crossesMidnight) {
            // Split the shift into multiple day portions
            var dayPortions_1 = [];
            var currentStart = moment(first_start_time);
            var totalDuration = last_end_time.diff(first_start_time, 'minutes');
            while (currentStart.isBefore(last_end_time)) {
                var currentEnd = void 0;
                // For the last day portion, use the actual end time
                if (currentStart.isSame(last_end_time, 'day')) {
                    currentEnd = moment(last_end_time);
                }
                else {
                    // For other days, end at 11:59 PM
                    currentEnd = moment(currentStart).endOf('day');
                }
                var portionDuration = currentEnd.diff(currentStart, 'minutes');
                var portion = portionDuration / totalDuration;
                var portionEarnings = entryTotal * portion;
                // Include ALL portions when viewing any date the shift touches
                if (moment(date).isSame(first_start_time, 'day') || moment(date).isSame(last_end_time, 'day')) {
                    var hours = Math.round(portionDuration / 60 * 10) / 10; // Round to 1 decimal
                    dayPortions_1.push({
                        start: moment(currentStart),
                        end: moment(currentEnd),
                        date: moment(currentStart),
                        portion: portion,
                        earnings: portionEarnings,
                        dayLabel: "".concat(currentStart.format('MMM DD').toUpperCase())
                    });
                }
                // Move to start of next day
                currentStart = moment(currentStart).add(1, 'day').startOf('day');
            }
            // Render as a single entry showing all day portions
            return (_jsxs(_Fragment, { children: [dayPortions_1.length > 1 && (_jsx("div", { className: "w-full mb-3 p-3 bg-yellow-50 border border-yellow-200 rounded-lg", children: _jsxs("div", { className: "flex items-center", children: [_jsx("div", { className: "bg-yellow-400 text-yellow-800 rounded-full w-6 h-6 flex items-center justify-center mr-3 flex-shrink-0", children: _jsx("span", { className: "text-xs font-bold leading-none", children: "!" }) }), _jsxs("div", { children: [_jsxs("div", { className: "text-yellow-800 font-medium text-sm mb-1", children: ["This shift spans ", dayPortions_1.length, " days:"] }), _jsx("div", { className: "text-yellow-700 text-xs space-y-1", children: dayPortions_1.map(function (portion, idx) {
                                                var hours = Math.round(portion.end.diff(portion.start, 'minutes') / 60 * 10) / 10;
                                                return (_jsxs("div", { children: ["\u2022 ", portion.start.format('MMM D'), ": ", hours, " hours ($", formatNum(portion.earnings), ")"] }, idx));
                                            }) })] })] }) })), _jsxs("div", { className: "flex justify-between items-start flex-col mb-4 py-2 bg-white rounded-lg shadow-sm", children: [dayPortions_1.map(function (dayPortion, index) {
                                // Format display times properly for day boundaries
                                var displayStart = dayPortion.start;
                                var displayEnd = dayPortion.end;
                                var displayEndTime = displayEnd.format("hh:mm A");
                                // If this ends at end of day (11:59:59 PM), show as 11:59 PM
                                if (displayEnd.hour() === 23 && displayEnd.minute() === 59) {
                                    displayEndTime = "11:59 PM";
                                }
                                // Calculate hours worked for display
                                var hoursWorked = dayPortion.end.diff(dayPortion.start, 'minutes') / 60;
                                var hoursDisplay = hoursWorked < 1 ? "".concat(Math.round(hoursWorked * 60), "m") : "".concat(Math.round(hoursWorked * 10) / 10, "h");
                                return (_jsxs("div", { className: "w-full", children: [_jsx("div", { className: "mb-1 pl-2", children: _jsx("span", { className: "text-gray-500 font-medium text-xs uppercase tracking-wide", children: dayPortion.dayLabel }) }), _jsxs("div", { className: "mb-2 flex justify-between items-center col text-[10px] w-full px-2", children: [_jsx("div", { className: "text-[#0A2342] rounded-lg bg-[#cce6e3] px-2 py-1", children: displayStart.format("D MMM") }), _jsx("div", { className: "text-[#0A2342] rounded-lg bg-[#ced3d9] px-2 py-1", children: displayStart.format("hh:mm A") }), _jsx(ArrowForwardOutlinedIcon, { style: { fontSize: 16, color: '#00A190' } }), _jsx("div", { className: "text-[#0A2342] rounded-lg bg-[#cce6e3] px-2 py-1", children: displayEnd.format("D MMM") }), _jsx("div", { className: "text-[#0A2342] rounded-lg bg-[#ced3d9] px-2 py-1", children: displayEndTime }), _jsxs("div", { className: "text-gray-300 text-[14px]", children: ["$", formatNum(dayPortion.earnings)] })] }), dayPortions_1.length > 1 && index === 0 && (_jsxs("div", { className: "mt-5 mb-2 px-2 flex items-center justify-center", children: [_jsx("div", { className: "flex-1 border-t border-dotted border-gray-300" }), _jsx("span", { className: "text-yellow-600 bg-yellow-100 px-2 py-1 rounded-lg text-xs mx-2", children: "\uD83C\uDF19 Crosses Midnight" }), _jsx("div", { className: "flex-1 border-t border-dotted border-gray-300" })] }))] }, "".concat(dateKey, "-portion-").concat(index)));
                            }), isLoggedIn && (_jsxs("div", { className: "mt-4 mb-2 pl-2", children: [_jsx("span", { className: "font-medium p-2 rounded-lg cursor-pointer bg-[#275082]", onClick: function () {
                                            setEditData({
                                                uuid: eventsForDate[0].uuid,
                                                selectedPosition: eventsForDate[0].position_relation.id.toString(),
                                                dateSelected: eventsForDate[0].date,
                                                startTime: first_start_time.format("HH:mm"),
                                                endTime: last_end_time.format("HH:mm"),
                                                vesselName: eventsForDate[0].vessel.name,
                                                shipName: eventsForDate[0].ship_name,
                                                headerName: eventsForDate[0].header_name,
                                                selectedBreaks: selectedBreaks
                                            });
                                            setShowEditLogModal(true);
                                        }, children: _jsx(EditIcon, { style: { color: 'white' } }) }), _jsx("span", { className: "ml-2 font-medium p-2 rounded-lg cursor-pointer bg-[#ECECEC]", onClick: function () { return handleDeleteEvent(dateKey); }, children: _jsx(DeleteIcon, { style: { color: '#0A2342' } }) })] }))] }, dateKey)] }));
        }
        // Single day shift - render normally
        return (_jsxs("div", { className: "flex justify-between items-start flex-col mb-4 py-2 bg-white rounded-lg shadow-sm", children: [_jsxs("div", { className: "mb-1 flex justify-between items-center col text-[10px] w-full px-2", children: [_jsx("div", { className: "text-[#0A2342] rounded-lg bg-[#cce6e3] px-2 py-1", children: first_start_time.format("D MMM") }), _jsx("div", { className: "text-[#0A2342] rounded-lg bg-[#ced3d9] px-2 py-1", children: first_start_time.format("hh:mm A") }), _jsx(ArrowForwardOutlinedIcon, { style: { fontSize: 16, color: '#00A190' } }), _jsx("div", { className: "text-[#0A2342] rounded-lg bg-[#cce6e3] px-2 py-1", children: last_end_time.format("D MMM") }), _jsx("div", { className: "text-[#0A2342] rounded-lg bg-[#ced3d9] px-2 py-1", children: last_end_time.format("hh:mm A") }), _jsxs("div", { className: "text-gray-300 text-[14px]", children: ["$", formatNum(entryTotal)] })] }, eventsForDate[0].id), isLoggedIn && _jsxs("div", { className: "mt-4 mb-2 pl-2", children: [_jsx("span", { className: "font-medium p-2 rounded-lg cursor-pointer bg-[#275082]", onClick: function () {
                                setEditData({
                                    uuid: eventsForDate[0].uuid,
                                    selectedPosition: eventsForDate[0].position_relation.id.toString(),
                                    dateSelected: eventsForDate[0].date,
                                    startTime: first_start_time.format("HH:mm"),
                                    endTime: last_end_time.format("HH:mm"),
                                    vesselName: eventsForDate[0].vessel.name,
                                    shipName: eventsForDate[0].ship_name,
                                    headerName: eventsForDate[0].header_name,
                                    selectedBreaks: selectedBreaks
                                });
                                setShowEditLogModal(true);
                            }, children: _jsx(EditIcon, { style: { color: 'white' } }) }), _jsx("span", { className: "ml-2 font-medium p-2 rounded-lg cursor-pointer bg-[#ECECEC]", onClick: function () { return handleDeleteEvent(dateKey); }, children: _jsx(DeleteIcon, { style: { color: '#0A2342' } }) })] })] }, dateKey));
    }).flat(); // Flatten the array since some entries might return multiple day portions
    // ---------------------- //
    //         RENDER
    // ---------------------- //
    return (_jsxs("div", { children: [_jsx(ToastContainer, { position: "top-right" }), isLoggedIn && seniority == "" && (_jsx("div", { className: "top right", children: _jsxs("div", { className: "bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 m-4", role: "alert", children: [_jsx("p", { className: "font-bold", children: "Profile Incomplete" }), _jsxs("p", { children: ["Please complete your profile to add logs.", " ", _jsx("button", { onClick: function () { return chaseListNavigate("#/profile"); }, className: "underline font-semibold", children: "Click here to update your profile." })] })] }) })), showAddLogModal && (_jsx(AddTimeLogs, { positions: positions, date: dateWithoutTimeZone, addLogHandle: function () {
                    getTimeLogs();
                    setShowAddLogModal(false);
                }, closeModal: function () { return setShowAddLogModal(false); } })), showEditLogModal && (_jsx(AddTimeLogs, { positions: positions, date: dateWithoutTimeZone, addLogHandle: function () {
                    getTimeLogs();
                    setShowEditLogModal(false);
                }, closeModal: function () { return setShowEditLogModal(false); }, editData: editData })), loading ? (_jsx("div", { className: "flex justify-center items-center h-[300px]", children: _jsx(Spinner, { size: 160 }) })) : (_jsxs("div", { className: "p-4 overflow-y-auto mb-[80px]", children: [view === 'day' && (_jsx(CustomToolbar, { label: '', date: date, view: view, onView: function (newView) {
                            setDateWithoutTimeZone("");
                            setView(newView);
                        }, onNavigate: function (action, newDate) {
                            var nextDate = date;
                            switch (action) {
                                case 'PREV':
                                    nextDate = moment(date).subtract(1, 'day').toDate();
                                    break;
                                case 'NEXT':
                                    nextDate = moment(date).add(1, 'day').toDate();
                                    break;
                                case 'TODAY':
                                    nextDate = new Date();
                                    break;
                                case 'DATE':
                                    nextDate = newDate !== null && newDate !== void 0 ? newDate : date;
                                    break;
                                default:
                                    nextDate = date;
                            }
                            setDate(nextDate);
                            calculateEarnings(nextDate);
                        } })), (function () {
                        var monthHolidays = (holidays || []).filter(function (h) {
                            return moment(h.date).isSame(date, "month");
                        });
                        if (view !== "month")
                            return null;
                        if (monthHolidays.length === 0)
                            return null;
                        return (_jsxs("div", { className: "mb-4 py-4", children: [_jsx("h3", { className: "text-lg font-medium mb-1 ml-2 text-gray-700", children: "Holidays" }), _jsx("ul", { className: "w-full space-y-2 bg-white rounded-lg text-sm text-gray-700 py-1", children: monthHolidays.map(function (h, idx) {
                                        var _a, _b;
                                        return (_jsxs("li", { className: "flex justify-between bg-white rounded px-2 py-1 items-center ".concat(idx === monthHolidays.length - 1 ? 'rounded-b-lg' : '', " ").concat(idx === 0 ? 'rounded-t-lg' : ''), children: [_jsxs("span", { className: "bg-[#275082] text-[#fff] py-2 px-4 w-26 text-center flex-row flex justify-center items-center rounded-lg", children: [_jsx("strong", { children: moment(h.date).format('D') }), "\u00A0", _jsx("small", { children: moment(h.date).format('MMM') })] }), _jsx("img", { src: images.greenarrowrightIcon, alt: "Right Arrow Icon", className: "w-[24px] h-[24px]" }), _jsx("span", { className: "w-28 text-left font-semibold green-text-color tabular-nums", children: (_b = (_a = h.name) !== null && _a !== void 0 ? _a : h.name) !== null && _b !== void 0 ? _b : "Holiday" })] }, idx));
                                    }) })] }));
                    })(), view === "day" && dailyGrossEarnings > 0 && (_jsxs("div", { className: "flex flex-row justify-start gap-2 item-center bg-[#0A2342] rounded-xl p-2 w-full mb-2", children: [_jsx("img", { src: images.mouseIcon, alt: "Mouse Icon", className: "w-[50px] h-[50px] mr-2" }), _jsxs("div", { className: "bg-[#183559] text-white text-center font-bold rounded-xl p-1 px-2 flex flex-col justify-center items-center", children: ["$", formatNum(dailyGrossEarnings)] }), _jsx("div", { className: "text-white mx-1 flex flex-col justify-center items-center text-[14px]", children: _jsx("span", { children: "Daily Earnings" }) })] })), view === "day" && dailyHourlyEarnings.length > 0 && (_jsx("div", { className: "mb-4 p-4 bg-white rounded-lg shadow-sm mt-1", children: _jsxs("ul", { className: "space-y-2", children: [_jsxs("li", { className: "flex justify-between", children: [_jsx("span", { children: "Gross Total Earnings:" }), _jsxs("span", { className: "text-green-600", children: ["+ $", formatNum(dailyGrossEarnings)] })] }), _jsxs("li", { className: "flex justify-between", children: [_jsx("span", { children: "Net Total Earnings:" }), _jsxs("span", { className: "text-green-600", children: ["+ $", formatNum(dailyNetEarnings)] })] }), deductedList.length > 0 && _jsx("li", { className: "flex justify-between", children: _jsx("span", { children: "Deduction Summary:" }) }), deductedList.map(function (deduction, idx) { return (_jsxs("li", { className: "flex justify-between", children: [_jsxs("span", { children: [deduction.label, ":"] }), _jsxs("span", { className: "text-red-600", children: ["- $", formatNum(deduction.deducated)] })] }, idx)); })] }) })), view === "day" && dailyHourlyEarnings.length > 0 && (_jsx(_Fragment, { children: groupedEventsComponent })), view === "day" && dailyHourlyEarnings.length > 0 && (_jsxs("div", { className: "mb-4 p-4 bg-white rounded-lg shadow-sm text-[#0A2342]", children: [_jsx("h3", { className: "text-lg font-medium mb-2 font-semibold", children: "Daily Hourly Rates" }), _jsx("ul", { className: "space-y-2 pr-4", children: dailyHourlyEarnings.map(function (rate, idx) {
                                    return Object.entries(rate).map(function (_a) {
                                        var r = _a[0], amount = _a[1];
                                        return (amount > 0 && _jsxs("li", { className: "flex items-center w-full", children: [_jsxs("span", { className: "w-1/3 flex items-center gap-1", children: [_jsxs("p", { className: "font-semibold", children: ["$", r] }), _jsx("p", { children: "/hr" })] }), _jsxs("span", { className: "w-1/3 text-center text-[#76808B]", children: [formatNum(amount / parseFloat(r)), " Hours"] }), _jsxs("span", { className: "w-1/3 flex items-center justify-start gap-1", children: [_jsx("p", { className: "text-[#76808B]", children: "Earned" }), _jsxs("p", { className: "font-semibold", children: ["$", formatNum(amount)] })] })] }, idx));
                                    });
                                }) })] })), _jsx(Calendar, { views: { month: true, agenda: false, day: CustomDayView, week: false }, localizer: localizer, events: calendarEvents, startAccessor: "start", endAccessor: "end", style: { height: view === "month" ? 480 : "100%" }, view: view, date: date, selectable: true, onNavigate: function (newDate) {
                            setDate(newDate);
                            calculateEarnings(newDate);
                        }, onView: function (newView) {
                            if (view === "month") {
                                setDate(new Date());
                            }
                            setDateWithoutTimeZone("");
                            calculateEarnings(new Date());
                            setView(newView);
                        }, dayPropGetter: dayPropGetter, components: {
                            toolbar: view === 'day' ? function () { return null; } : CustomToolbar,
                            month: {
                                dateHeader: function (props) { return (_jsx(CustomDayTimeLog, { date: props.date, events: calendarEvents, onClick: function () { return handleDateClick(props.date); } })); },
                                event: function () { return null; },
                            },
                            agenda: {
                                event: function (props) { return (_jsx(AgendaEventTimeLog, { event: props.event, onDelete: function () { } })); },
                            },
                            day: {
                                event: function (props) { return (_jsx(AgendaEventTimeLog, { event: props.event, onDelete: function () { } })); },
                            },
                            week: { event: CustomWeekEvent },
                        }, viewProps: {
                            onDeleteEvent: handleDeleteEvent, // Dummy function to satisfy CustomDayViewProps
                            localizer: localizer // localizer is required by CustomDayViewProps
                        } }), view === "month" && (_jsxs("div", { className: "flex flex-col items-start justify-between rounded-xl mt-4", children: [_jsxs("div", { className: "flex flex-row justify-between item-center bg-[#0A2342] rounded-xl p-2 w-full", children: [_jsx("img", { src: images.mouseIcon, alt: "Mouse Icon", className: "w-[50px] h-[50px] mr-2" }), _jsxs("div", { className: "bg-[#183559] text-white text-center font-bold rounded-xl p-1 px-2 flex flex-col justify-center items-center", children: ["$", formatNum(monthlyEarnings)] }), _jsx("div", { className: "text-white mx-1 flex flex-col justify-center items-center text-[14px]", children: _jsx("span", { children: "Monthly Earnings" }) }), _jsxs("div", { className: "bg-[#183559] text-white text-center font-bold rounded-xl p-1 px-2 flex flex-col justify-center items-center", children: [monthlyHours.toFixed(0), " H"] })] }), _jsx("h3", { className: "font-medium my-2 text-[#0A2342] text-[14px] font-semibold", children: "Weekly Breakdown" }), weeklyEarnings.length > 0 ? (_jsx("ul", { className: "w-full space-y-2 bg-white rounded-lg text-sm text-gray-700", children: weeklyEarnings.map(function (week, index) { return (_jsxs("li", { className: "flex items-center gap-3 bg-white shadow-sm px-4 py-2 text-sm text-gray-700 ".concat(index === weeklyEarnings.length - 1 ? 'rounded-b-lg' : '', " ").concat(index === 0 ? 'rounded-t-lg' : ''), children: [_jsxs("span", { className: "bg-[#275082] text-[#fff] py-2 px-4 w-16 text-center flex-col flex justify-center items-center rounded-lg", children: [_jsx("strong", { children: moment(week.from).format('D') }), _jsx("small", { children: moment(week.from).format('MMM') })] }), _jsx("img", { src: images.greenarrowrightIcon, alt: "Right Arrow Icon", className: "w-[24px] h-[24px]" }), _jsxs("span", { className: "bg-[#275082] text-[#fff] py-2 px-4 w-16 text-center flex-col flex justify-center items-center rounded-lg", children: [_jsx("strong", { children: moment(week.to).format('D') }), _jsx("small", { children: moment(week.to).format('MMM') })] }), _jsx("span", { className: "flex-1" }), _jsx("span", { className: "w-28 text-left tabular-nums", children: formatNum(week.hours) + ' Hrs' }), _jsxs("span", { className: "w-28 text-left font-semibold green-text-color tabular-nums", children: ["$", formatNum(week.amount)] })] }, index)); }) })) : (_jsx("p", { className: "text-gray-400 text-sm", children: "No weekly data available." })), _jsx("h3", { className: "font-medium mb-2 text-[#0A2342] text-[14px] font-semibold my-4", children: "Current Season Earnings" }), seasonalStats.length > 0 ? ((function () {
                                // Determine current season year key
                                var today = date;
                                var currentSeasonYear = today.getMonth() >= 9 ? today.getFullYear() : today.getFullYear() - 1;
                                var currentSeason = seasonalStats.find(function (season) { return String(season.year) === String(currentSeasonYear); });
                                if (!currentSeason)
                                    return _jsx("p", { className: "text-gray-400 text-sm", children: "No seasonal data available for this month." });
                                var startLabel = moment(new Date(currentSeasonYear, 9, 1)); // Oct YYYY
                                var endLabel = moment(new Date(currentSeasonYear + 1, 8, 1)); // Sep YYYY
                                return (_jsx("ul", { className: "w-full space-y-2", children: _jsxs("li", { className: "flex flex-col items-center gap-1  bg-white shadow-sm px-4 py-2 text-sm text-gray-700 rounded-lg", children: [_jsxs("div", { className: "flex items-center gap-3 w-full", children: [_jsxs("span", { className: "bg-[#275082] text-[#fff] py-2 px-4 w-24 text-center flex-col flex justify-center items-center rounded-lg", children: [_jsx("strong", { children: startLabel.format('YYYY') }), _jsx("small", { children: startLabel.format('MMM') })] }), _jsx("img", { src: images.greenarrowrightIcon, alt: "Right Arrow Icon", className: "w-[24px] h-[24px]" }), _jsxs("span", { className: "bg-[#275082] text-[#fff] py-2 px-4 w-24 text-center flex-col flex justify-center items-center rounded-lg", children: [_jsx("strong", { children: endLabel.format('YYYY') }), _jsx("small", { children: endLabel.format('MMM') })] }), _jsx("span", { className: "flex-1" }), _jsx("span", { className: "w-28 text-left tabular-nums", children: formatNum(currentSeason.hours) + ' Hrs' }), _jsxs("span", { className: "w-28 text-right font-semibold green-text-color tabular-nums", children: ["$", formatNum(currentSeason.amount)] })] }), strikeFundPercentage && strikeFundPercentage > 0 && (_jsxs("div", { className: "flex items-center gap-3 w-full", children: [_jsx("span", { className: "bg-[#275082] text-[#fff] py-2 px-4 w-26 text-center flex-col flex justify-center items-center rounded-lg", children: _jsxs("strong", { children: ["Strike Fund (", strikeFundPercentage, "%)"] }) }), _jsx("img", { src: images.greenarrowrightIcon, alt: "Right Arrow Icon", className: "w-[24px] h-[24px]" }), _jsx("span", { className: "flex-1" }), _jsx("span", { className: "w-28 text-right font-semibold green-text-color tabular-nums", children: '$' + formatNum((strikeFundPercentage / 100) * currentSeason.amount) })] }))] }) }));
                            })()) : (_jsx("p", { className: "text-gray-400 text-sm", children: "No seasonal data available for this month." }))] }))] }))] }));
};
export default TimeLogs;
// Update the date formatting function with type
var formatDate = function (date) {
    return moment(date).format("DD MMM");
};
// Smart number formatter: show 2 decimals only if fractional part exists
var formatNum = function (value) {
    if (!isFinite(value))
        return '0';
    var rounded = Math.round((value + Number.EPSILON) * 100) / 100;
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2);
};
